import { createSelector } from '@reduxjs/toolkit';

import { selectSubjectAddressDisplay } from '../selectSubjectAddressDisplay.ts';
import { selectAdditionalStructureCommentaryTableDisplay } from './selectAdditionalStructureCommentary.ts';
import { selectAllCostApproachExportData } from './selectAllCostApproachExportData.ts';
import { selectConditionCommentaryTableDisplay } from './selectConditionCommentary.ts';
import { selectExternalDepreciationCommentaryTableDisplay } from './selectExternalDepreciationCommentary.ts';
import { selectFunctionalDepreciationCommentaryTableDisplay } from './selectFunctionalDepreciationCommentary.ts';
import { selectMainDwellingCostsCommentaryDisplay } from './selectMainDwellingCostsCommentary.ts';
import { selectMarketAdjustmentsCommentaryData } from './selectMarketAdjustmentsCommentary.ts';
import { selectQualityCommentaryTableDisplay } from './selectQualityCommentary.ts';
import { selectSiteExtractionCommentaryTableDisplay } from './selectSiteExtractionCommentary.ts';

export const selectAllCommentaryData = createSelector(
  [
    selectMainDwellingCostsCommentaryDisplay,
    selectAdditionalStructureCommentaryTableDisplay,
    selectConditionCommentaryTableDisplay,
    selectFunctionalDepreciationCommentaryTableDisplay,
    selectExternalDepreciationCommentaryTableDisplay,
    selectQualityCommentaryTableDisplay,
    selectSiteExtractionCommentaryTableDisplay,
    selectMarketAdjustmentsCommentaryData,
    selectAllCostApproachExportData,
    selectSubjectAddressDisplay,
  ],
  (
    mainDwelling,
    additionalStructures,
    condition,
    functionalDepreciation,
    externalDepreciation,
    quality,
    siteExtraction,
    marketAdjustments,
    costApproach,
    subjectAddressDisplay,
  ) => ({
    mainDwelling,
    additionalStructures,
    condition,
    functionalDepreciation,
    externalDepreciation,
    quality,
    siteExtraction,
    marketAdjustments,
    costApproach,
    subjectAddressDisplay,
  }),
);
